<template>
    <div class="text-center">
        <div v-if="timestamp">
            <div class="font-size-lg">{{ $localDate(timestamp, dateFormat) }}</div>
            <span class="text-muted">
                {{ __('general.at') }} {{ $localTime(timestamp, timeFormat) }} {{ __('general.clock') }}
            </span>
        </div>
        <div v-else class="text-muted">&dash;</div>
    </div>
</template>

<script>
export default {
    name: 'DateTime',

    props: {
        timestamp: String,
        dateFormat: {
            type: Object,
            default: () => {
                return {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                }
            },
        },
        timeFormat: {
            type: Object,
            default: () => {
                return {
                    hour: '2-digit',
                    minute: '2-digit',
                }
            },
        },
    },
}
</script>
